import { AIRY_PRODUCT_CARD } from '@/previewThemes/imageSlots';
import type { ThemeMeta, ThemeTokens } from '@/previewThemes/meta';

export const tokens: ThemeTokens = {
  headingFont: null,
  accent: null,
  monoFont: null,
  headingTracking: '0',
  headingTransform: 'none',
  containerMax: '64rem',
  spaceScale: 1.25,
  headerHeight: '3.5rem',
};

export const meta: ThemeMeta = {
  label: 'Minimal',
  hint: 'Narrow, quiet and sparse. The products do the talking.',
  industries: ['beauty_cosmetics', 'salon_beauty_services', 'health_wellness', 'pharmacy_medical', 'clinics', 'general'],
  look: {
    // Almost no colour at all. The one saturated value is the button, and
    // it is muted enough that a page of products still outranks it.
    colors: {
      primary: '#2f3e46',
      background: '#ffffff',
      surface: '#f4f5f4',
      text: '#20272b',
      muted: '#7d8a91',
    },
    typography: { font_family: 'Inter', heading_weight: '500' },
    buttons: { radius_px: 2, style: 'outline' },
    catalog: 'beauty',
  },
  // `listing.card` and `search.card` are `airy` in `theme.tsx`, which
  // ProductCard draws `aspect-[3/4]`; the product page keeps the default square
  // gallery. See `imageSlots.ts`.
  imageSpecs: { PRODUCT: AIRY_PRODUCT_CARD },
};
